var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMountain = function SvgMountain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 54,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#423C58",
    d: "M3.734 54h44.844l-3.706-5.953H53L37.865 22.931l-4.277 7.056-5.746-9.203v-6.17h15.489l-6.497-7.306L43.33 0H24.48v20.784l-5.42 8.684-3.924-6.532L0 48.052h7.422zm34.114-24.563 9.215 15.272h-4.277l-7.203-11.526zM21.676 45.12l4.485-5.262 4.484 5.257 4.417-6.505 7.518 12.04H9.782l7.5-12.006zm-15.774-.418 9.215-15.272 1.945 3.227-7.523 12.046H5.901z"
  })));
};
export default SvgMountain;